<span class="link-container" [style.width]="width"
  ><a
    routerLink="{{ destination }}"
    [ngClass]="_classes"
    target="{{ openInNewTab ? '_blank' : '_self' }}"
    ><ng-content /><span
      class="material-symbols-outlined link-icon-container"
      [class.link-circle-right-show]="showIcon"
      [class.link-circle-right-hide]="!showIcon"
      >expand_circle_right</span
    >
  </a>
</span>
